/**
 * @generated SignedSource<<24f2a3f3ffc9af620152bb1484c88846>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type ShowMoreFooter_connection$fragmentType = any;
type row_auditEvent$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type List_organization$fragmentType: FragmentType;
export type List_organization$data = {|
  +auditEvents: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentSpreads: row_auditEvent$fragmentType,
      |},
    |}>,
    +$fragmentSpreads: ShowMoreFooter_connection$fragmentType,
  |},
  +name: string,
  +slug: string,
  +$fragmentType: List_organization$fragmentType,
|};
export type List_organization$key = {
  +$data?: List_organization$data,
  +$fragmentSpreads: List_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "List_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        }
      ],
      "concreteType": "OrganizationAuditEventConnection",
      "kind": "LinkedField",
      "name": "auditEvents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationAuditEventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AuditEvent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "row_auditEvent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node/*: any*/).hash = "6f06546e953f21fd00d19edea848e13c";

module.exports = ((node/*: any*/)/*: Fragment<
  List_organization$fragmentType,
  List_organization$data,
>*/);
